import { ParsedUrlQuery } from 'querystring';

export const extractString = (query: ParsedUrlQuery, name: string): string | null => {
    const value = query[name];
    return typeof value === 'string' ? value : null;
};

export const parseNonNegativeInt = (value: QueryParam): number | null => {
    if (typeof value === 'string') {
        const parsedValue = Number(value);
        if (Number.isInteger(parsedValue) && parsedValue >= 0) {
            return parsedValue;
        }
    }
    return null;
};

export const parsePositiveInt = (value: QueryParam): number | null => {
    const parsedValue = parseNonNegativeInt(value);
    return parsedValue === 0 ? null : parsedValue;
};

export const parseBoolean = (value: QueryParam): boolean | null => {
    switch (value) {
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
};

export const parseArray = (value: QueryParam): null | string[] => {
    if (typeof value === 'string') {
        return [value];
    }
    if (Array.isArray(value)) {
        return value;
    }
    return null;
};

export const parseSlugAndId = (value: QueryParam): [number, string] | null => {
    if (typeof value !== 'string') {
        return null;
    }

    const idInSlugRegex = /^(?<id>[1-9][0-9]*)-(?<slug>.+)$/;

    const matches = idInSlugRegex.exec(value);
    const slug = matches?.groups?.slug;
    const idString = matches?.groups?.id;

    if (slug === undefined || idString === undefined) {
        return null;
    }

    const id = parsePositiveInt(idString);

    if (id !== null) {
        return [id, slug];
    }

    return null;
};
